import _ from 'lodash';
import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import ThumbnailButtonGroup from '../thumbnailButtonGroup/thumbnailButtonGroup';
var ColoredDiv = function ColoredDiv(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('control-thumbnail-color-input-item', {
      'selected-item': props.isSelected
    }),
    style: {
      backgroundColor: props.color
    }
  });
};
var getOptions = function getOptions(_ref) {
  var options = _ref.options,
    selectedIndex = _ref.selectedIndex;
  return _.map(options, function (opt, i) {
    return _.defaults({
      illustration: ColoredDiv({
        color: opt.color,
        isSelected: selectedIndex === i
      }),
      onClick: function onClick() {
        return opt.onClick(opt, i);
      }
    }, opt);
  });
};
var ThumbnailColorInput = function ThumbnailColorInput(_ref2) {
  var options = _ref2.options,
    selectedIndex = _ref2.selectedIndex,
    maxThumbsPerRow = _ref2.maxThumbsPerRow,
    getClassName = _ref2.getClassName,
    dataHook = _ref2.dataHook;
  return /*#__PURE__*/React.createElement(ThumbnailButtonGroup, {
    className: getClassName('control-thumbnail-color-input'),
    dataHook: dataHook,
    options: getOptions({
      options: options,
      selectedIndex: selectedIndex
    }),
    maxThumbsPerRow: maxThumbsPerRow
  });
};
ThumbnailColorInput.displayName = displayNames.THUMBNAIL_COLOR_INPUT;
ThumbnailColorInput.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** The colors to display <ul>
   *   <li><code>color</code> - A single color in HEX (<code>#ADD8E6</code>), HSL (<code>hsl(195, 53.3%, 79%)</code>), RGB (<code>rgb(173, 216, 230)</code>) or RGBA (<code>rgba(173, 216, 230, 0.75)</code>)</li>
   *   <li><code>disabled</code> - If set to <code>true</code> the option will not be selectable</li>
   *   <li><code>onClick</code> - Handles click on the option. Parameters: <ol>
   *     <li><code>option</code> - the option object</li>
   *     <li><code>index</code> - the index of the option in <code>options</code> list</li>
   *   </ol></li>
   * </ul> */
  options: PropTypes.arrayOf(PropTypes.shape({
    color: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool
  })).isRequired,
  /** The index of the selected color */
  selectedIndex: PropTypes.number,
  /** Maximum number of colors per row. Should not exceed 5. */
  maxThumbsPerRow: PropTypes.number.isRequired
};
export default compose(ThumbnailColorInput);